import { render, staticRenderFns } from "./ViewAgreementPage.vue?vue&type=template&id=3893eab6&scoped=true&"
import script from "./ViewAgreementPage.vue?vue&type=script&lang=js&"
export * from "./ViewAgreementPage.vue?vue&type=script&lang=js&"
import style0 from "./ViewAgreementPage.vue?vue&type=style&index=0&id=3893eab6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3893eab6",
  null
  
)

export default component.exports